import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { useState } from "react";
import { checkString, isNotUndefined, isNotUndefinedOrNull } from "../FunctionsCore";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import AccordionStyles from "./AccordionStyles.module.scss";
const styles = AccordionStyles;
const classCombiner = classCombinerFromPrefix("e148c9c270ca179c");
// TODO Hack to fix unexpected array in JSON
const secondElementOfStringArray = (input) => {
    if (typeof input === "string") {
        return input;
    }
    if (isNotUndefinedOrNull(input)) {
        return input[1];
    }
    return void 0;
};
const AccordionItemComponent = (properties) => {
    const accordionItem = properties.accordionItem;
    const [isOpen, setIsOpen] = useState(false);
    const onClickOrKeydown = () => setIsOpen((bo) => !bo);
    return (_jsxs("div", Object.assign({ className: cx(classCombiner(styles, "accordion-items")), onClick: onClickOrKeydown, onKeyDown: onClickOrKeydown }, { children: [_jsx("button", Object.assign({ className: cx(classCombiner(styles, "accordionTrigger"), classCombiner(styles, `open-${isOpen}`)), type: "button" }, { children: _jsx("span", { className: cx(classCombiner(styles, "title")), dangerouslySetInnerHTML: { "__html": accordionItem.accordionTitle } }) })), _jsx("div", { className: cx(classCombiner(styles, "detail"), classCombiner(styles, `open-${isOpen}`)), dangerouslySetInnerHTML: { "__html": accordionItem.accordionDescription } })] })));
};
const AccordionComponent = (props) => {
    const accordionItems = props.accordionItems;
    const properties = props.properties;
    const headingTag = properties.heading_tag;
    const headingTagClass = properties.heading_tag_class;
    const headingText = properties.headingText;
    const listheader = properties.listheader;
    const headingTagClassString = secondElementOfStringArray(headingTagClass);
    const headingTagString = secondElementOfStringArray(headingTag);
    const headingTextString = secondElementOfStringArray(headingText);
    const HeadingTagOrHThree = (isNotUndefined(headingTagString)
        && headingTagString !== null
        && headingTagString.length > 0
        ? headingTagString
        : "h3");
    return (_jsxs("div", Object.assign({ className: cx(classCombiner(styles, "accordion")) }, { children: [checkString(headingTextString) ? (_jsx(HeadingTagOrHThree, Object.assign({ className: cx(headingTagClassString) }, { children: headingTextString }))) : (_jsx(_Fragment, {})), _jsx("div", Object.assign({ className: cx(classCombiner(styles, "list-header")) }, { children: listheader })), _jsx("ul", Object.assign({ className: cx(classCombiner(styles, "accordion-list")) }, { children: accordionItems.map((ac, nu) => _jsx(AccordionItemComponent, { accordionItem: ac }, nu)) }))] })));
};
const accordionShared = (renderableData) => renderIdentifierGeneric(AccordionComponent, renderableData);
export { accordionShared };
